module.exports = __webpack_public_path__ + "static/media/red-number-5.06e18f86.png";